import { z } from 'zod';
// =========================================================
// Umbrales de alerta parametrizables.
//
// Modelo: una fila por (clave). El comparador define cómo se aplica el
// umbral al valor para decidir si la celda/ítem se resalta como alerta.
// El frontend hace un solo GET de toda la tabla y aplica el umbral en cada
// celda por `clave`.
//
// Convención de claves:
//   batches.<columna>     — para resaltado en la tabla "Datos de planta".
//   lab.umbral_<algo>     — para el módulo Laboratorio (cumplimiento).
// =========================================================
export const COMPARADORES_UMBRAL = ['gte_abs', 'gt_abs', 'gte', 'gt', 'lte', 'lt'];
export const ComparadorUmbralSchema = z.enum(COMPARADORES_UMBRAL);
export const UmbralAlertaSchema = z.object({
    clave: z.string().max(80),
    descripcion: z.string().nullable(),
    umbral: z.number(),
    comparador: ComparadorUmbralSchema,
    /** Unidad para mostrar al lado del valor (ej. "%", "L"). NULL = sin unidad. */
    unidad: z.string().max(20).nullable(),
    activo: z.boolean(),
    actualizado_en: z.string(),
    actualizado_por_email: z.string().nullable(),
});
export const ListaUmbralesResponseSchema = z.object({
    umbrales: z.array(UmbralAlertaSchema),
});
export const ActualizarUmbralRequestSchema = z.object({
    umbral: z.number().optional(),
    comparador: ComparadorUmbralSchema.optional(),
    activo: z.boolean().optional(),
    descripcion: z.string().max(200).nullable().optional(),
    unidad: z.string().max(20).nullable().optional(),
});
/**
 * Aplica un umbral a un valor y devuelve `true` si debe alertar.
 * Si el umbral está desactivado o no se encuentra, devuelve `false`.
 *
 * Compartido entre frontend (resaltado de celdas) y backend (evaluación
 * server-side de cumplimiento).
 */
export function aplicarUmbral(valor, cfg) {
    if (!cfg || cfg.activo === false)
        return false;
    switch (cfg.comparador) {
        case 'gte_abs':
            return Math.abs(valor) >= cfg.umbral;
        case 'gt_abs':
            return Math.abs(valor) > cfg.umbral;
        case 'gte':
            return valor >= cfg.umbral;
        case 'gt':
            return valor > cfg.umbral;
        case 'lte':
            return valor <= cfg.umbral;
        case 'lt':
            return valor < cfg.umbral;
    }
}
//# sourceMappingURL=umbrales.js.map